import React, { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import GroupShopTableHeadGroup from '../../components/molecules/GroupShopTableHeadGroup';
import GroupShopTableBodyGroup from '../../components/molecules/GroupShopTableBodyGroup';
// import TablePagination from '../../components/molecules/TablePagination';
// import ExPagination from '../../components/molecules/ExPagination';
import { addRelationShop, getShops } from '../../actions/Shop';
import { sendLogin } from '../../auth/Auth';
import ConfirmDialog from '../../components/molecules/ConfirmDialog';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import ContentDialog from '../../components/molecules/ContentDialog';

const styles = {
  scrollTable: {
    // maxHeight: '60vh',
    overflowX: 'scroll',
    whiteSpace: 'nowrap'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      shops: state.shops.shops,
      accessibleShops: state.shops.accessibleShops,
      totalCount: state.shops.totalCount,
      offset: state.shops.offset
    }),
    dispatch => ({
      actions: bindActionCreators({ addRelationShop, getShops }, dispatch)
    })
  ),
  setPropTypes(propTypes),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('openRelationConfirm', 'updateOpenRelationConfirm', false),
  withState('openRelationCaution', 'updateOpenRelationCaution', false),
  withState('openRelationProgress', 'updateOpenRelationProgress', false),
  withState('loading', 'updateLoading', false),
  withState('isRelationSuccess', 'updateIsRelationSuccess', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('shopName', 'setShopName', ''),
  withState('shopRelationParams', 'setShopRelationParams', null),
  withState('message', 'setMessage', ''),
  withState('rowsPerPage', 'setRowsPerPage', 100),
  withState('order', 'setOrder', 'asc'),
  withState('orderBy', 'setOrderBy', 'shopId'),
  withState('page', 'setPage', 0),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleChangeRowsPerPage: props => (event, rowsPerPage) => {
      props.setRowsPerPage(rowsPerPage);
    },
    handleRequestSort: props => property => {
      const isDesc = props.orderBy === property && props.order === 'desc';
      props.setOrder(isDesc ? 'asc' : 'desc');
      props.setOrderBy(property);
    }
  }),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    checkSession,
    roles,
    searchKey,
    page,
    selectedPage,
    totalCount,
    // offset,
    handleChangePage,
    shops,
    rowsPerPage,
    order,
    orderBy,
    // handleChangeRowsPerPage,
    handleRequestSort,
    openRelationConfirm,
    updateOpenRelationConfirm,
    openRelationCaution,
    updateOpenRelationCaution,
    openRelationProgress,
    updateOpenRelationProgress,
    loading,
    updateLoading,
    isRelationSuccess,
    updateIsRelationSuccess,
    resultMessage,
    setResultMessage,
    shopName,
    setShopName,
    shopRelationParams,
    setShopRelationParams,
    message,
    setMessage
  }) => {
    const emptyRows =
      rowsPerPage - Math.min(rowsPerPage, totalCount - page * rowsPerPage);

    useEffect(() => {
      if (!shopRelationParams) {
        return;
      }
      if (shopRelationParams.otherGroupBankAccount) {
        setMessage(
          `「${shopName}」には、すでに他のグループが銀行口座を設定しているため、銀行口座の変更ができません。グループ店舗として紐付けてよろしいですか？`
        );
      } else {
        setMessage(
          `「${shopName}」をグループ店舗として紐付けます。よろしいですか？`
        );
      }
    }, [shopName]);

    const shopRelationAction = onClickParams => {
      setShopRelationParams(onClickParams);
      setShopName(onClickParams.shopName);
      if (onClickParams.stripeUseSwitchable) {
        updateOpenRelationConfirm(true);
      } else {
        updateOpenRelationCaution(true);
      }
    };

    const shopRelationOkAction = async () => {
      updateLoading(true);
      updateOpenRelationProgress(true);
      const params = {
        groupId: searchKey.groupId,
        shopId: shopRelationParams.shopId
      };
      const relationShop = await actions
        .addRelationShop(params)
        .then(addData => checkSession(addData));
      if (relationShop.type === 'ADD_RELATION_SHOP_SUCCESS') {
        updateIsRelationSuccess(true);
        // actions.getShops(searchKey);
        handleChangePage(null, selectedPage, rowsPerPage);
        setResultMessage('店舗紐付けが完了しました。');
        updateLoading(false);
      } else {
        updateIsRelationSuccess(false);
        setResultMessage('店舗紐付けに失敗しました。');
        updateLoading(false);
      }
    };

    const progressOkAction = () => {
      if (isRelationSuccess) {
        updateOpenRelationConfirm(false);
        updateOpenRelationProgress(false);
      } else {
        updateOpenRelationProgress(false);
      }
    };

    return (
      <div>
        <div className={classes.scrollTable} id="scrollTableId">
          <Table stickyHeader>
            <GroupShopTableHeadGroup
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              roles={roles}
            />
            <GroupShopTableBodyGroup
              shops={shops}
              emptyRows={emptyRows}
              page={page}
              rowsPerPage={rowsPerPage}
              shopRelationAction={shopRelationAction}
              roles={roles}
              order={order}
              orderBy={orderBy}
            />
          </Table>
        </div>
        {/* {(roles.isGroup || roles.isSecretariat || roles.isDeveloper) && (
          <div>
            <ExPagination
              searchResults={shops}
              rowsPerPage={rowsPerPage}
              page={page}
              handleChangePage={handleChangePage}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
              totalCount={totalCount}
              offset={offset}
              selectedPage={selectedPage}
            />
          </div>
        )} */}
        <ConfirmDialog
          openConfirm={openRelationConfirm}
          updateOpenConfirm={updateOpenRelationConfirm}
          okAction={shopRelationOkAction}
          message={message}
        />
        <ProgressDialog
          openProgress={openRelationProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
        <ContentDialog
          openContent={openRelationCaution}
          updateOpenContent={updateOpenRelationCaution}
          content="『自社で入金管理する』を選択した店舗のグループ紐付けを解除した場合、グループ再紐付は当月内にはできません。 support@gochimeshi.com までお問い合わせください。"
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
